import EUserType from 'enums/userTypes';

export interface IAuthDataAuthorization {
  accessToken: string | null;
}

interface IWorker {
  all_interventions: boolean;
  company_details: boolean;
  intervention_ids: number[];
  invoice_permission: boolean;
  trader_id?: number;
  user_management: boolean;
}

interface ITrader {
  matching_locales: string[];
  mobile_phone?: string;
  phone?: string;
  treetrades: number[];
  vat_number?: string;
  website_url?: string;
}

export interface IAuthDataProfile extends ITrader, IWorker {
  address?: string;
  city?: string;
  companyname?: string;
  email?: string;
  firstname?: string;
  iban?: string;
  // Common
  id?: number;
  intervention_partnership_id?: number;
  lastname?: string;
  locale?: string;
  role?: EUserType;
  zip?: string;
}

export interface IAuthData {
  authorization: IAuthDataAuthorization;
  changePassword: {
    config: {
      isLoading: boolean;
    };
  };
  config: {
    isLoading: boolean;
  };
  createPassword: {
    config: {
      isLoading: boolean;
    };
  };
  edit: {
    config: {
      isLoading: boolean;
    };
  };
  editCompany: {
    config: {
      isLoading: boolean;
    };
  };
  forgotPassword: {
    config: { email: string; isLoading: boolean };
  };
  profile: IAuthDataProfile;
  resetPassword: {
    config: { isLoading: boolean };
  };
}

const authInitialState: IAuthData = {
  authorization: { accessToken: null },
  changePassword: {
    config: {
      isLoading: false,
    },
  },
  editCompany: {
    config: {
      isLoading: false,
    },
  },
  edit: {
    config: {
      isLoading: false,
    },
  },
  createPassword: {
    config: {
      isLoading: false,
    },
  },
  config: {
    isLoading: false,
  },
  forgotPassword: {
    config: {
      isLoading: false,
      email: '',
    },
  },
  profile: {
    email: undefined,
    id: undefined,
    firstname: undefined,
    lastname: undefined,
    locale: undefined,
    mobile_phone: undefined,
    companyname: undefined,
    matching_locales: [],
    intervention_ids: [],
    vat_number: undefined,
    address: undefined,
    city: undefined,
    phone: undefined,
    intervention_partnership_id: undefined,
    website_url: undefined,
    iban: undefined,
    zip: undefined,
    role: undefined,
    treetrades: [],
    trader_id: undefined,
    company_details: false,
    invoice_permission: false,
    user_management: false,
    all_interventions: false,
  },
  resetPassword: {
    config: {
      isLoading: false,
    },
  },
};

export default authInitialState;
